// Rejects filenames that could be used for path traversal (`..`, `/`, `\`, `:` — the latter
// because macOS silently translates a Finder-typed `/` into `:` on disk)
// or to break out of the HTML/URL context they get embedded into later (`< > " '`),
// as well as control characters and `%` (browsers percent-encode `"`/CR/LF as literal
// `%22`/`%0D`/`%0A` text in the multipart filename, which would otherwise slip through unnoticed).
// Anything else (spaces, accents, parentheses...) is allowed.
const FORBIDDEN_PATTERN = /\.\.|[\/\\:%\x00-\x1f<>"']/

export function isValidFilename(filename) {
    return typeof filename === 'string' && filename.length > 0 && !FORBIDDEN_PATTERN.test(filename)
}